import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const denyReportedUser = async (reportedUserId: string) => {
  const [response, bodyOrError] = await Api.patch(`reports/${reportedUserId}/deny-reported-user`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDenyReportedUser = () => {
  const queryClient = useQueryClient();

  return useMutation('denyReportedUser', denyReportedUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getReportedUserById']);
      queryClient.invalidateQueries('reportedUsers');
    },
  });
};
